import React, { useRef, useEffect, useState } from "react";
import { Tooltip } from "@ss/mtd-react3";

const EllipsisTooltip = ({
    children,
    content,
    className = "",
    style = {},
    compareWidth,
    ...rest
}) => {
    const measureRef = useRef(null);
    const [isOverflow, setIsOverflow] = useState(false);
    const [measured, setMeasured] = useState(false);
    const [contentWidth, setContentWidth] = useState(0);

    useEffect(() => {
        if (!measureRef.current) return;
        const width = measureRef.current.scrollWidth;
        setContentWidth(width);
        if (typeof compareWidth === "number") {
            setIsOverflow(width > compareWidth);
        }
        setMeasured(true);
    }, [content, children, compareWidth, style, className]);

    const measureNode = (
        <h3
            ref={measureRef}
            className={className}
            style={{
                ...style,
                position: "absolute",
                visibility: "hidden",
                height: "auto",
                width: "auto",
                whiteSpace: "nowrap",
                pointerEvents: "none",
                zIndex: -9999
            }}
            {...rest}
        >
            {children}
        </h3>
    );

    const realPNode = (
        <h3
            className={className}
            style={{
                ...style,
                cursor: isOverflow ? "pointer" : "default",
                whiteSpace: "nowrap",
                overflow: isOverflow ? "hidden" : undefined,
                textOverflow: isOverflow ? "ellipsis" : undefined
            }}
            {...rest}
        >
            {children}
        </h3>
    );

    if (!measured) {
        return measureNode;
    }

    return isOverflow ? (
        <Tooltip message={content} placement="top">
            {realPNode}
        </Tooltip>
    ) : (
        realPNode
    );
};

export default EllipsisTooltip;
